import { render, staticRenderFns } from "./TasksPastDueChart.vue?vue&type=template&id=6251653f&"
import script from "./TasksPastDueChart.vue?vue&type=script&lang=ts&"
export * from "./TasksPastDueChart.vue?vue&type=script&lang=ts&"
import style0 from "./TasksPastDueChart.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
